import React, { useCallback, useEffect, useMemo, useState } from "react";

import {
  Box,
  Button,
  Card,
  Flex,
  Grid,
  SearchBox,
  PageHeading,
  Loader,
  NoData,
  Toastify,
} from "atoms";
import Table from "molecules/Table";
import { statusColor } from "utilities/constants";
import { AddNewUserModal, ConfirmationModal } from "molecules/Modals";
import MemoDeleteIcon from "assets/icons/DeleteIcon";
import MemoEdit from "assets/icons/Edit";
import MemoBlock from "assets/icons/Block";
import MemoAdd from "assets/icons/Add";
import { usePropsoch } from "contexts/Propsoch";
import MemoUnblock from "assets/icons/Unblock";
import { useAuth } from "contexts/Auth";

const columns = [
  {
    title: "Role",
    field: "role",
    sortKey: "role",
    render: (row) => <>{row.role}</>,
  },
  {
    title: "Email",
    field: "email",
    sortKey: "email",
    render: (row) => <>{row.createdAt}</>,
  },
  {
    title: "Status",
    field: "status",
    sortKey: "status",
    render: (row) => (
      <Box
        color="white"
        p="0.4rem 1.6rem"
        width="fit-content"
        borderRadius="1rem"
        fontSize="1.2rem"
        fontFamily="NeometricBold"
        textTransform="capitalize"
        bg={statusColor(row.status.toLowerCase())}
      >
        {row.status}
      </Box>
    ),
  },
  // {
  //   title: "Email",
  //   field: "email",
  //   sortKey: "email",
  //   render: (row) => <>{row.email}</>,
  // },
  // {
  //   title: "Status",
  //   field: "status",
  //   sortKey: "status",
  //   render: (row) => (
  //     <Box
  //       color="white"
  //       p="0.4rem 1.6rem"
  //       width="fit-content"
  //       borderRadius="1rem"
  //       fontSize="1.2rem"
  //       fontFamily="NeometricBold"
  //       textTransform="capitalize"
  //       bg={statusColor(row.status.toLowerCase())}
  //     >
  //       {row.status}
  //     </Box>
  //   ),
  // },

  {
    title: "Actions",
    // rightAligned: true,
    render: (row) => (
      <Grid
        gridAutoFlow="column"
        gridGap="1.8rem"
        justifyContent="start"
        alignItems="center"
        color="neutral.600"
      >
        <Box color="neutral.900" cursor="pointer">
          <MemoEdit height="1.8rem" width="1.8rem" />
        </Box>
        <Box color="neutral.900" cursor="pointer">
          <MemoBlock height="2rem" width="2rem" />
        </Box>
        <Box color="accents.100" cursor="pointer">
          <MemoDeleteIcon height="2rem" width="2rem" />
        </Box>
      </Grid>
    ),
  },
];

const Users = () => {
  const [search, setSearch] = useState("");
  const [isModalVisible, setModalVisible] = useState(false);

  const {
    state: { userData },
  } = useAuth();
  // users crud
  const {
    state: { users, roles, userRole },
    actions: {
      getUsers,
      createUser,
      activateDeactivateUser,
      deleteUser,
      getRoles,
    },
  } = usePropsoch();

  const [loading, setLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const fetchUsers = useCallback(() => {
    setLoading(true);
    getUsers()
      .then(() => {})
      .catch(console.error)
      .finally(() => {
        setLoading(false);
      });
  }, [getUsers]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  const isAuthorisedToAdd = useMemo(() => {
    return userRole?.isSuperadmin;
  }, [userRole?.isSuperadmin]);

  const isAuthorisedToEdit = useMemo(() => {
    return userRole?.isSuperadmin;
  }, [userRole?.isSuperadmin]);

  const isAuthorisedToDelete = useMemo(() => {
    return userRole?.isSuperadmin;
  }, [userRole?.isSuperadmin]);

  return (
    <Box>
      <Flex justifyContent="space-between" pb="2.4rem">
        <PageHeading text="Users" mt="1.8rem" />
        <Button
          variant="primary"
          width="fit-content"
          px="2rem"
          height="4.8rem"
          onClick={() => setModalVisible({ visible: true })}
          disabled={!isAuthorisedToAdd}
        >
          <Flex justifyContent="center" alignItems="center" gridGap="2rem">
            <MemoAdd />
            Add New User
          </Flex>
        </Button>
      </Flex>
      <Card>
        <SearchBox
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onClose={() => setSearch("")}
          placeholder="Search Users"
          style={{ width: "30rem" }}
          removeValidationIcon={!search}
        />
        <Box mt="2.4rem" {...(loading && { minHeight: "4rem" })}>
          <Loader loading={loading}>
            <Table
              tableHeader={columns.map(({ title, rightAligned }) => ({
                name: title,
                rightAligned,
                containerProps: {
                  fontSize: "1.4rem",
                  fontWeight: "600",
                },
              }))}
              borderColor="neutral.500"
            >
              <Box as="tbody" bg="white">
                {users
                  ?.filter((user) =>
                    user?.email?.toLowerCase()?.includes(search?.toLowerCase())
                  )
                  ?.map((user, index) => (
                    <tr key={index}>
                      <td>{user?.roles?.name}</td>
                      <td>{user?.email}</td>
                      <td>
                        {
                          <Box
                            color="white"
                            p="0.4rem 1.6rem"
                            width="fit-content"
                            borderRadius="1rem"
                            fontSize="1.2rem"
                            fontFamily="NeometricBold"
                            textTransform="capitalize"
                            bg={statusColor(user?.isActive)}
                          >
                            {user?.isActive ? "Active" : "Blocked"}
                          </Box>
                        }
                      </td>
                      <td>
                        <Grid
                          gridAutoFlow="column"
                          gridGap="1.8rem"
                          justifyContent="start"
                          alignItems="center"
                          color="neutral.600"
                        >
                          {/* <Box
                          color="neutral.900"
                          cursor="pointer"
                          onClick={() =>
                            setModalVisible({ visible: true, user })
                          }
                        >
                          <MemoEdit height="1.8rem" width="1.8rem" />
                        </Box> */}
                          <Box
                            color={
                              isAuthorisedToEdit && userData?.id !== user?.id
                                ? "neutral.900"
                                : "neutral.300"
                            }
                            cursor={
                              isAuthorisedToEdit && userData?.id !== user?.id
                                ? "pointer"
                                : "not-allowed"
                            }
                            onClick={() => {
                              if (
                                isAuthorisedToEdit &&
                                userData?.id !== user?.id
                              ) {
                                setDeleteModal({
                                  onClose: () => setDeleteModal(false),
                                  icon: {
                                    Icon: user?.isActive
                                      ? MemoBlock
                                      : MemoUnblock,
                                    ICprops: { color: "neutral.900" },
                                  },
                                  textOne: "Are you sure you want to",
                                  textTwo: user?.isActive ? "block" : "unblock",
                                  textThree: `the user ${user?.email}`,
                                  onConfirm: () => {
                                    setLoading(true);
                                    activateDeactivateUser(
                                      user?.id,
                                      !user?.isActive
                                    )
                                      ?.then(() => {
                                        user?.isActive
                                          ? Toastify(
                                              "success",
                                              `${user?.email} blocked`
                                            )
                                          : Toastify(
                                              "success",
                                              `${user?.email} unblocked`
                                            );
                                      })
                                      ?.catch(console.error)
                                      .finally(() => {
                                        fetchUsers();
                                      });
                                    setDeleteModal(false);
                                  },
                                });
                              }
                            }}
                          >
                            {user?.isActive ? (
                              <MemoBlock height="2rem" width="2rem" />
                            ) : (
                              <MemoUnblock height="2rem" width="2rem" />
                            )}
                          </Box>
                          <Box
                            color={
                              isAuthorisedToDelete && userData?.id !== user?.id
                                ? "accents.100"
                                : "neutral.300"
                            }
                            cursor={
                              isAuthorisedToDelete && userData?.id !== user?.id
                                ? "pointer"
                                : "not-allowed"
                            }
                            onClick={() => {
                              if (
                                isAuthorisedToDelete &&
                                userData?.id !== user?.id
                              ) {
                                setDeleteModal({
                                  onClose: () => setDeleteModal(false),
                                  icon: {
                                    Icon: MemoDeleteIcon,
                                    ICprops: { color: "accents.100" },
                                  },
                                  textOne: "Are you sure you want to",
                                  textTwo: "delete",
                                  textThree: `the user ${user?.email}`,
                                  onConfirm: () => {
                                    setLoading(true);
                                    deleteUser(user?.id)
                                      ?.then(() => {
                                        Toastify(
                                          "success",
                                          `${user?.email} deleted successfully`
                                        );
                                      })
                                      ?.catch((e) => {
                                        console.error(e);
                                        Toastify(
                                          "error",
                                          `Failed to delete ${user?.email}`
                                        );
                                      })
                                      .finally(() => {
                                        fetchUsers();
                                      });
                                    setDeleteModal(false);
                                  },
                                });
                              }
                            }}
                          >
                            <MemoDeleteIcon height="2rem" width="2rem" />
                          </Box>
                        </Grid>
                      </td>
                    </tr>
                  ))}
              </Box>
            </Table>
            {users?.filter((user) =>
              user?.email?.toLowerCase()?.includes(search?.toLowerCase())
            )?.length === 0 && <NoData />}
          </Loader>
          {/* <RcePagination
        data={data}
        current={current}
        setCurrent={setCurrent}
        showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
      /> */}
        </Box>
      </Card>
      {isModalVisible?.visible && (
        <AddNewUserModal
          isOpen={isModalVisible?.visible}
          onClose={() => setModalVisible(false)}
          loading={isModalVisible?.loading}
          getSelectRoleOptions={getRoles}
          roleOptions={roles}
          error={isModalVisible?.error}
          resetError={() =>
            setModalVisible((prev) => ({
              ...prev,
              error: "",
            }))
          }
          // preUser={isModalVisible?.user}
          onSubmit={({ ...values }) => {
            setModalVisible((prev) => ({ ...prev, loading: true }));
            createUser(values)
              ?.then(() => {})
              ?.catch((e) =>
                setModalVisible((prev) => ({
                  ...prev,
                  loading: false,
                  error: e?.message,
                }))
              )
              .finally(() => {
                setModalVisible(false);
                fetchUsers();
              });
          }}
        />
      )}
      {deleteModal && <ConfirmationModal {...deleteModal} />}
    </Box>
  );
};

export default Users;
